/// <amd-module name="Repos/Views/PullRequest/Components/ActivityFeed/ActivityCards/UpdateCard" />
import * as React from "react";
import { IterationCard } from "Repos/Views/PullRequest/Components/PullRequestDetails/IterationCard";
import { Components } from "VSS/Platform/Layout";
import { IIteration } from "../../../Contracts/PullRequest";

export interface IUpdateCardProps {
    isShim?: boolean;
    iteration?: IIteration;
}

export const UpdateCard: React.FunctionComponent<IUpdateCardProps> = props => {
    if (!props.iteration) {
        return null;
    }
    return <IterationCard className="flex-grow" iteration={props.iteration} isShim={props.isShim}></IterationCard>;
};

Components.add("ms.vss-code-web.update-activity-card", UpdateCard);
